import { render, staticRenderFns } from "./PlasterGrain.vue?vue&type=template&id=4ebc769a&"
import script from "./PlasterGrain.vue?vue&type=script&lang=js&"
export * from "./PlasterGrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports